export const resizerSx = {
  position: 'absolute',
  top: 0,
  right: -2,
  zIndex: 1,
  height: '100%',
  px: 1,
  my: 'auto',
  cursor: 'col-resize',
  userSelect: 'none',
  touchAction: 'none',
  opacity: 0,
  '&.isResizing': {
    opacity: 1,
    '>div': {
      background: 'B.80',
    },
  },
  '>div': {
    background: 'M.50',
    width: '1px',
    my: 3,
    height: 6,
  },
};
